import { all } from 'redux-saga/effects'

import watchAuth from './auth'
import watchSafeWalk from './safewalk'
import watchChat from './chat'
import watchConfig from './config'
import watchEngage from './engage'
import watchError from './error'
import watchFiles from './tips-files'
import watchInitialize from './initialize'
import watchMessage from './message'
import watchPanicButton from './panicButton'
import watchLocation from './location'
import watchRoutes from './routes'
import watchSearchlight from './searchlight'
import watchTips from './tips'
import watchUI from './ui'

/**
 * Root saga that forks all domain-specific watcher sagas in parallel.
 */
export default function * rootSaga() {
  yield all([
    watchAuth(),
    watchSafeWalk(),
    watchChat(),
    watchConfig(),
    watchEngage(),
    watchError(),
    watchFiles(),
    watchInitialize(),
    watchLocation(),
    watchMessage(),
    watchPanicButton(),
    watchRoutes(),
    watchSearchlight(),
    watchTips(),
    watchUI()
  ])
}
